import { Group, Box, Text, Stack } from "@mantine/core";
import type { TransitLeg } from "@/api/types";
import { TransportIcon } from "./TransportIcon";
import { getTransportConfig } from "./transportConfig";

interface TransitLegRowProps {
  leg: TransitLeg;
  isLast: boolean;
}

export function TransitLegRow({ leg, isLast }: TransitLegRowProps) {
  const config = getTransportConfig(leg.type);

  const formatDistance = (meters: number) => {
    if (meters >= 1000) {
      return `${(meters / 1000).toFixed(1)} km`;
    }
    return `${meters} m`;
  };

  return (
    <Group gap="sm" align="flex-start">
      <Stack gap={4} align="center">
        <Text size="xs" c="dimmed" fw={500} w={48} ta="right" pr="xs">
          {leg.origin_time}
        </Text>

        <Box
          w={32}
          h={32}
          style={{
            borderRadius: "50%",
            backgroundColor: `${config.color}20`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TransportIcon type={leg.type} size="md" />
        </Box>

        {!isLast && (
          <Box
            w={2}
            style={{
              flex: 1,
              minHeight: 24,
              backgroundColor: `${config.color}40`,
            }}
          />
        )}
      </Stack>

      <Box pb="md" style={{ flex: 1 }}>
        <Group gap="xs">
          {leg.type === "WALK" ? (
            <Text size="sm" fw={500}>
              Walk {leg.distance_meters ? formatDistance(leg.distance_meters) : ""}
            </Text>
          ) : (
            <Text size="sm" fw={500} style={{ color: config.color }}>
              {leg.line_name || config.label}
            </Text>
          )}
          <Text size="xs" c="dimmed">
            {leg.duration_minutes} min
          </Text>
        </Group>

        <Text size="sm" c="dimmed" mt={2}>
          {leg.origin_name} → {leg.destination_name}
        </Text>

        {leg.direction && (
          <Text size="xs" c="dimmed" mt={2}>
            → {leg.direction}
          </Text>
        )}
      </Box>
    </Group>
  );
}
